import AnalyticsEvent from './analytics-event';
import type { IdPosition } from '@bc/shared';

export enum UserDisplayEventAction {
  HOVER = 'hover',
  DISPLAY = 'display',
}

export interface UserDisplayEventProps {
  component: string;
  action: UserDisplayEventAction;
  value?: string;
  section_position?: number;
  section_type?: string;
  id_section?: string;
  id_algo?: number;
  id_business_event?: number;
  id_banner?: string;
  value_proposition?: string;
  itemtype?: string;
  nb_tiles?: number;
  nb_brands?: number;
  id_brand?: IdPosition[];
  id_product?: IdPosition[];
  collection_uuids?: { uuid: string; position: number; name?: string }[];
  banner_name?: string;
  promocode?: string;
}

export type SectionDisplayProperties = Omit<UserDisplayEventProps, 'component' | 'action'>;

export class UserDisplayEvent extends AnalyticsEvent {
  public readonly name: string = 'User Display';

  constructor(public readonly properties: UserDisplayEventProps) {
    super();
  }
}
